import { Box } from "@mui/material";
import SortDropdown from "../filters/browseSort";
import SearchFilter from "../filters/searchFilter";

const BrowseFilters = ({ data, setSortedData, setTier }) => {
  const categoryStatusOptions = [
    {
      value: "price",
      defaultLabel: "Select Tier",
      disabled: true,
    },
    {
      value: "All",
      label: "All Tiers",
      sortFunction: (a, b) => a.categoryTitle.localeCompare(b.category),
    },
    {
      value: 1,
      label: "Tier One",
      sortFunction: (a, b) => a.categoryTitle.localeCompare(b.category),
    },
    {
      value: 2,
      label: "Tier Two",
      sortFunction: (a, b) => a.categoryTitle.localeCompare(b.category),
    },
    {
      value: 3,
      label: "Tier Three",
      sortFunction: (a, b) => a.categoryTitle.localeCompare(b.category),
    },
    {
      value: 4,
      label: "Tier Four",
      sortFunction: (a, b) => a.categoryTitle.localeCompare(b.category),
    },
  ];
  const recentlySortingOptions = [
    {
      value: "price",
      defaultLabel: "Recently Added",
      disabled: true,
    },
    {
      value: "priceLowest",
      label: "Price: Lowest",
      sortFunction: (a, b) => a.fixedPrice - b.fixedPrice,
    },
    {
      value: "priceHighest",
      label: "Price: Highest",
      sortFunction: (a, b) => b.fixedPrice - a.fixedPrice,
    },
    {
      value: "dateOldest",
      label: "Date: Oldest",
      sortFunction: (a, b) => new Date(a.danftNamete) - new Date(b.date),
    },
    {
      value: "dateNewest",
      label: "Date: Newest",
      sortFunction: (a, b) => new Date(b.date) - new Date(a.date),
    },
  ];
  const handleSearchChange = (e) => {
    const query = e.target.value.toLowerCase();

    const filteredResults = data.filter(
      (item) => item.title && item.title.toLowerCase().includes(query)
    );

    setSortedData(filteredResults);
  };
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
        width: "100%",
        backgroundColor: "#2D2342",
      }}
    >
      <Box width="40%">
        <SortDropdown
          data={data}
          setSortedData={setSortedData}
          sortingOptions={categoryStatusOptions}
          setTier={setTier}
        />
      </Box>

      <Box display="flex" gap="20px" width="100%" pl={5}>
        <SearchFilter
          handleChange={handleSearchChange}
          placeholder="Search by NFT name"
        />
        {/* <SortDropdown
          data={data}
          setSortedData={setSortedData}
          sortingOptions={recentlySortingOptions}
        /> */}
      </Box>
    </Box>
  );
};
export default BrowseFilters;
